import { action, props } from 'ts-action';
import {
  Annotation,
  PreviousAnnotationTask,
} from '../types/annotation-tasks.type';

export const setAnnotation = action(
  '[AnnotationTask] set annotation',
  props<{ annotation: Annotation | null }>(),
);

export const setPreviousAnnotationTask = action(
  '[AnnotationTask] set previous annotation task',
  props<{ previousAnnotationTask: PreviousAnnotationTask | null }>(),
);
